import { Button } from 'primereact/button';
import { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import AddCountry from './AddNewCountry';
import '../../../assests/css/common/responsive-ui.css';
import { countryModel } from '../../../models/cust-address/cust-address-model';
import { Toast } from 'primereact/toast';

interface SearchPanelProps {
  reloadPage: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setcountryList: (countries: countryModel[]) => void;
  setTotalRecords: (total: number) => void;
  setSearchTerm: (searchTerm: any) => void;
  fetchData: (searchTerm: string, pageNumber: number, pageSize: number) => void;
}

const CountrySearch: React.FC<SearchPanelProps> = ({
  setPageNumber,
  setPageSize,
  setSearchTerm,
  fetchData,
}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>('');
  const [isAddCountryDialogVisible, setAddCountryDialogVisible] = useState(false);
  const toast = useRef<Toast>(null);

  const resetSearchFields = () => {
    setSearchText('');
    setPageNumber(1);
    setPageSize(10);
    fetchData('', 1, 10);
  };

  const hideAddCountryDialog = () => {
    setAddCountryDialogVisible(false);
  };

  const handleCountryAddSuccess = () => {
    toast.current?.show({
      severity: 'success',
      summary: 'Success',
      detail: 'Country added successfully!',
      life: 3000,
    });
    setSearchText('');
    fetchData('', 1, 10);
    setAddCountryDialogVisible(false);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const trimmed = searchText.trim();
      if (trimmed.length >= 1) {
        setPageNumber(1);
        setPageSize(10);
        fetchData(trimmed, 1, 10);
        setSearchTerm(trimmed);
      } else if (trimmed.length === 0) {
        fetchData('', 1, 10);
        setSearchTerm('');
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              placeholder="Keyword Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: "left", textAlign: 'right', width: "10%" }}>
            <Button
              className="text-black border-round"
              style={{ width: "100%", textAlign: 'center' }}
              onClick={resetSearchFields}
              severity="success"
              raised
            >
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-green-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setAddCountryDialogVisible(true)}
              severity="secondary"
              text
              raised
            >
              Add
            </Button>
          </div>
        </div>

        {isAddCountryDialogVisible && (
          <AddCountry
            showCountryDialog={isAddCountryDialogVisible}
            hideCountryDialog={hideAddCountryDialog}
            handleAddSuccess={handleCountryAddSuccess}
          />
        )}
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default CountrySearch;
